import React, {useState, useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import Modal from "react-modal";
import "../CryptoPage.css"; // Assuming you have a CSS file for styling
import {fontSize, fontWeight} from "@mui/system";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import PromoBanner from "../promoBanner.js";
import UserAvatar from "../userAvatar.js";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import {styled} from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {ButtonGroup, BottomNavigation, Paper, Chip, Button} from "@mui/material";
import SidebarMenuList from "../../includes/sidebarMenuList";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {Grid, useStepContext} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import {ContactSupportOutlined, Recommend} from "@mui/icons-material";
import {Link, useLocation} from "react-router-dom";
import {Tabs, Tab} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import {keyframes} from "@mui/system";
import LoadingButton from "@mui/lab/LoadingButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MenuItem from "@mui/material/MenuItem";
import ClearIcon from "@mui/icons-material/Clear"; // Import ClearIcon
import InputAdornment from "@mui/material/InputAdornment";
import {Link as RouterLink} from "react-router-dom";
import {FormControlLabel, Radio, RadioGroup, Popover, Checkbox, TextField} from "@mui/material";
import Divider from "@mui/material/Divider";
import ListSubheader from "@mui/material/ListSubheader";
import {Helmet} from "react-helmet";
import {tabLink} from "../../common/constant/tablink";
import BottomTab from "../../common/hooks/BottomTab.jsx";
import LoginPopUp from "../../common/alert/login/LoginPopUp.jsx";

// Define the keyframes for the left-right motion animation
const leftRightMotion = `
  @keyframes leftRightMotion {
    0% {
      transform: translateX(-30px); /* Start 30px left of center */
    }
    50% {
      transform: translateX(30px);  /* Move 30px right of center */
    }
    100% {
      transform: translateX(-30px); /* Return to 30px left of center */
    }
  }
`;

const drawerWidth = 292;

const useStyles = styled((theme) => ({
    tableContainer: {
        maxWidth: 900,
        margin: "0 auto",
    },
    table: {
        display: "none", // Hide the table on all screens
        [theme.breakpoints.down("sm")]: {
            display: "table", // Show the table on small screens only (mobile view)
        },
    },
}));

const CryptoInfluencerRankings = (props) => {
    const {window1} = props;
    const {crypto} = useParams();
    const [dropdownVisible, setDropdownVisible] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("fd_asc");
    const [sortDropdownVisible, setSortDropdownVisible] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [predictionLoader, setPredictionLoader] = useState(false);
    const [slug, setSlug] = useState(false);
    const [sevenDays, setSevenDays] = useState(false);
    const [thirtyDays, setThirtyDays] = useState(false);
    const [yearDays, setYearDays] = useState(false);
    const [rowsToShow, setRowsToShow] = useState(7);
    const [selectedSort, setSelectedSort] = useState("");
    const sortRef = useRef();
    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [portfolioData, setPortfolioData] = useState([]);
    const location = useLocation();
    const loc = location.pathname;
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [bouncingRow, setBouncingRow] = useState(null);

    const [sortOrderRank, setSortOrderRank] = useState("Highest To Lowest");
    const [sortOrderWinRate, setSortOrderWinRate] = useState("Low To High");
    const [sortOrderDate, setSortOrderDate] = useState("Most Recent");

    const handleGoBack = () => {
        navigate(-1); // Go back to the previous page
    };
    const [liked, setLiked] = useState(false);

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const mediaQueryVar1 = useMediaQuery(
        json2mq({
            minWidth: 400,
        })
    );
    const mediaQueryVar2 = useMediaQuery(
        json2mq({
            maxWidth: 420,
        })
    );
    const mediaQueryVar3 = useMediaQuery(
        json2mq({
            maxWidth: 410,
        })
    );
    const [selectedTab, setSelectedTab] = useState("Portfolios");
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const openfilter = Boolean(anchorEl);
    const handleCloseeoption = () => {
        setAnchorEl(null);
    };
    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            border: 0,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            border: 0,
        },
    }));

    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));

    const handleModalClose = () => {
        // Close the modal and reset the URL to the welcome page
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    };

    const handleLoginClick = () => {
        // Mask the URL by adding /login at the end without navigating
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        // Open the login modal
        setLoginModalOpen(true);
    };

    const isSmallScreen = useMediaQuery(
        json2mq({
            maxWidth: 380,
        })
    );

    const StyledTableRow = styled(TableRow)(({theme}) => ({
        // hide last border

        "& td, & th": {
            border: 0,
        },
    }));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
            <SidebarMenuList />
        </div>
    );

    const container = window1 !== undefined ? () => window1().document.body : undefined;

    const [isTableView, setIsTableView] = useState(true);
    const [selectedButton, setSelectedButton] = useState("CoinPrices");

    // State to manage likes
    const [likeUpdated, setLikeUpdated] = useState(false);
    const [sortOrder, setSortOrder] = useState(""); // Default to descending
    const [sortByLikes, setSortByLikes] = useState(""); // Asc or Desc
    const [sortByRanks, setSortByRanks] = useState(""); // Asc or Desc
    const [originalData, setOriginalData] = useState([...data]); // To store original unsorted data

    const handleSortByLikesChange = (event) => {
        const value = event.target.value;
        setSortByLikes(value);

        const sortedData = [...data].sort((a, b) => {
            if (value === "asc") {
                return a.likes - b.likes; // Low to High
            } else {
                return b.likes - a.likes; // High to Low
            }
        });

        setData(sortedData); // Update the sorted data
    };
    const handleSortByRanksChange = (event) => {
        const value = event.target.value;
        setSortByRanks(value);

        const sortedData = [...data].sort((a, b) => {
            if (value === "asc") {
                return a.rank - b.rank; // Low to High
            } else {
                return b.rank - a.rank; // High to Low
            }
        });

        setData(sortedData); // Update the sorted data
    };
    const handleClearAll = () => {
        setData(originalData); // Reset to original data
        setAnchorEl(null);
        setSortByLikes(""); // Clear the sort selection
        setSortByRanks("");
    };

    const handleSort = () => {
        const newSortOrder = sortOrder === "desc" ? "asc" : "desc";
        setSortOrder(newSortOrder);
        const sortedData = [...data].sort((a, b) => {
            if (newSortOrder === "desc") {
                return b.likes - a.likes; // Sort from highest to lowest
            } else {
                return a.likes - b.likes; // Sort from lowest to highest
            }
        });
        setData(sortedData); // Assuming you have a setData function to update the table
    };
    const handleSortRank = () => {
        const newSortOrder = sortOrder === "desc" ? "asc" : "desc";
        setSortOrder(newSortOrder);
        setSortOrderRank((prev) => (prev === "Highest To Lowest" ? "Lowest To Highest" : "Highest To Lowest"));
        const sortedData = [...data].sort((a, b) => {
            if (newSortOrder === "desc") {
                return b.rank - a.rank; // Sort from highest to lowest
            } else {
                return a.rank - b.rank; // Sort from lowest to highest
            }
        });
        setData(sortedData); // Assuming you have a setData function to update the table
    };
    const handleSortWinRate = () => {
        const newSortOrder = sortOrder === "desc" ? "asc" : "desc";
        setSortOrder(newSortOrder);
        setSortOrderWinRate((prev) => (prev === "Low To High" ? "High to Low" : "Low To High"));
        const sortedData = [...data].sort((a, b) => {
            const winRateA = parseFloat(a.win_rate.replace("%", "")); // Convert "77%" to 77
            const winRateB = parseFloat(b.win_rate.replace("%", "")); // Convert "85%" to 85

            if (newSortOrder === "desc") {
                return winRateB - winRateA; // Sort from highest to lowest
            } else {
                return winRateA - winRateB; // Sort from lowest to highest
            }
        });

        setData(sortedData); // Assuming you have a setData function to update the table
    };
    const handleSortDate = () => {
        const newSortOrder = sortOrderDate === "Most Recent" ? "Oldest First" : "Most Recent";
        setSortOrderDate(newSortOrder);

        const sortedData = [...data].sort((a, b) => {
            const dateA = new Date(a.latest_updated_on);
            const dateB = new Date(b.latest_updated_on);

            if (newSortOrder === "Most Recent") {
                return dateB - dateA; // Descending: Most recent first
            } else {
                return dateA - dateB; // Ascending: Oldest first
            }
        });

        setData(sortedData);
    };

    useEffect(() => {
        const fetchInfluencerMetrics = async () => {
            try {
                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/calculateAllInfluencerMetrics", {
                    // Adjust the URL to match your API endpoint
                    method: "POST", // Assuming a POST request is needed
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({}), // If no parameters are required, you can leave this as an empty object
                });

                const result = await response.json();
                console.log(result);
                if (result.code === "200") {
                    const sortedData = result.data.sort((a, b) => b.combined_metric - a.combined_metric);
                    // Add rank to each item in sortedData
                    const rankedData = sortedData.map((item, index) => ({
                        ...item, // Spread the original item properties
                        rank: index + 1, // Add rank based on array index (1-based rank)
                    }));

                    setOriginalData(rankedData);
                    // Set the final sorted data
                    setData(rankedData);
                } else {
                    setError(result.message);
                }
            } catch (err) {
                setError("An error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchInfluencerMetrics(); // Ensure the fetch function is called
    }, []); // Empty dependency array since there are no dependencies

    const handleLike = async (forecasterId) => {
        const userId = JSON.parse(localStorage.getItem("cw_portfolio_user"))?.user_id;
        try {
            const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/updateLike", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({forecasterId, userId}),
            });

            const result = await response.json();
            if (result.code === "200") {
                // Update the like count in the local state based on the backend response
                setData((prevData) => {
                    return prevData.map((item) =>
                        item.forecaster_id === forecasterId
                            ? {...item, likes: result.data.newLikeCount} // Set to the new like count from the backend
                            : item
                    );
                });
                setLikeUpdated(true);
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError("An error occurred while updating the like.");
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setSortDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = (index) => {
        setDropdownVisible(dropdownVisible === index ? null : index);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredData = data.filter((obj) => obj.forecaster_name.toLowerCase().includes(searchTerm.toLowerCase()));

    const handleLoadMore = () => {
        setRowsToShow(rowsToShow + 7);
    };

    const compareValues = (val1, val2, order = "asc") => {
        if (val1 === "Pending") return 1; // Ensure 'Pending' is always last
        if (val2 === "Pending") return -1; // Ensure 'Pending' is always last
        if (order === "asc") return val1 > val2 ? 1 : val1 < val2 ? -1 : 0;
        return val1 < val2 ? 1 : val1 > val2 ? -1 : 0;
    };

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        if (filteredData && filteredData.length > 0) {
            setIsDataLoaded(true); // Set to true when data is available
        }
    }, [filteredData]);

    const handleButtonClick = (buttonName) => {
        // If the same button is clicked again, don't toggle the view
        if (selectedButton === buttonName) {
            return;
        }

        // Toggle the view based on the clicked button
        setSelectedButton(buttonName);
        setIsTableView(buttonName === "CoinPrices" ? false : true); // Show table view only if 'CoinPrices' is selected
    };

    const [isPredictionDataLoaded, setIsPredictionDataLoaded] = useState(false);

    const currentUrl = window.location.pathname; // Get the current URL path

    const [unreadAlerts, setUnreadAlerts] = useState(0);
    useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlertsCount = async () => {
            try {
                const formData = new URLSearchParams();
                formData.append("user_id", userId); // convert to form-encoded format

                const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                    },
                    body: formData, // ✅ correct format for this content type
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);
                setUnreadAlerts(data.unread_notifications);
            } catch (error) {
                console.error("Failed to fetch alerts:", error);
            }
        };

        fetchAlertsCount();
    }, []);
    const formatDateTime = (dateString) => {
        const [datePart] = dateString.split(" "); // Ignore time
        const [year, month] = datePart.split("-"); // day isn't needed here

        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const monthIndex = parseInt(month, 10) - 1;
        const formattedMonth = monthNames[monthIndex] || "";

        return `${formattedMonth}, ${year}`;
    };

    const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: "4px 10px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "15px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[
                            tabLink["influencer_ranking"],
                            tabLink["influencer_ranking_prediction"],
                            tabLink["screener"],
                        ].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "5px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {!mediaQueryVar ? tab.mobile_name : tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };
    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["influencer_ranking"], tabLink["influencer_ranking_prediction"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                             {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["presale"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    return (
        <div
            className="crypto-page"
            style={{backgroundColor: mediaQueryVar ? "#EDF1F6" : "white", fontFamily: "'Satoshi', sans-serif"}}
        >
            <Helmet>
                <title>Crypto Influencer Rankings</title>
            </Helmet>

            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: {xs: "block", sm: "none"},
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth,
                        backgroundColor: "white",
                        color: "#727376",
                    },
                }}
            >
                {drawer}
            </Drawer>

            {mediaQueryVar ? (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: drawerWidth,
                        width: `calc(100% - ${drawerWidth}px)`,
                        backgroundColor: "#ffffff",
                        zIndex: 1000,
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        height: "100px", // You may need to increase this if banner + nav exceeds 100px
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <PromoBanner />
                    <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                </div>
            ) : null}

            {mediaQueryVar ? null : (
                <Box mt={16} mb={4}>
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0, // aligns it to the right of the sidebar
                            width: "100%", // takes full width minus sidebar
                            backgroundColor: "#ffffff",
                            zIndex: 1000,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            height: "100px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <PromoBanner />
                        <TopNavigationMobile unreadAlerts={unreadAlerts} />
                    </div>

                    <TextField
                        placeholder="Search Portfolios, Predictions Cryptos"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        size="small"
                        sx={{
                            marginTop: "70px",
                            width: "100%",
                            backgroundColor: "#fff",
                            borderRadius: "50px",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "46px",
                                height: "48px",
                                paddingRight: "8px",
                                "& .MuiOutlinedInput-input": {
                                    padding: "12px 8px", // Controls input text padding
                                    height: "24px", // Ensures proper vertical alignment
                                },
                                "& fieldset": {
                                    border: "1px solid #1877F2",
                                },
                            },
                            "& input::placeholder": {
                                color: "#1877F2",
                                opacity: 1,
                                fontSize: "16px",
                                fontWeight: "400",
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <img
                                        src="/images/search-new-2.svg"
                                        alt="search"
                                        width="18.872"
                                        height="18.868"
                                        style={{marginLeft: "20px"}}
                                    />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            )}

            {mediaQueryVar ? null : (
                <Box
                    display="flex"
                    alignItems="center"
                    mb={4}
                    sx={{
                        columnGap: "12px",
                        rowGap: "8px",
                        width: "100%", // Ensure the Box takes the full width
                    }}
                >
                    {/* Pills aligned to the right of the Sort By button */}
                                        <Box
                                            display="flex"
                                            flexWrap="wrap"
                                            justifyContent="center"
                                            flexGrow={1}
                                            gap="12px"
                                            sx={{minWidth: "200px"}}
                                        >
                                            {["Rank: Highest To Lowest", "ROI: High To Low", "Last Updated: Most Recent"].map(
                                                (label, idx) => (
                                                    <Button
                                                        key={idx}
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={
                                                            label === "ROI: High To Low"
                                                                ? handleSortWinRate
                                                                : label === "Rank: Highest To Lowest"
                                                                ? handleSortRank
                                                                : label === "Last Updated: Most Recent"
                                                                ? handleSortDate
                                                                : undefined
                                                        }
                                                        sx={{
                                                            borderRadius: "20px",
                                                            textTransform: "none",
                                                            fontSize: "8px",
                                                            fontWeight: "400",
                                                            border: "1px solid #1877F2",
                                                            color: "#1877F2",
                                                            backgroundColor: "#fff",
                                                            padding: "2px 8px 2px 8px",
                                                            height: "17px",
                                                            minWidth: mediaQueryVar3 ? "100px" : "130px",
                                                            "&:hover": {
                                                                backgroundColor: "#f5faff",
                                                                borderColor: "#1877F2",
                                                            },
                                                        }}
                                                    >
                                                        {label === "Rank: Highest To Lowest"
                                                            ? `Rank: ${sortOrderRank}`
                                                            : label === "ROI: High To Low"
                                                            ? `ROI: ${sortOrderWinRate}`
                                                            : label === "Last Updated: Most Recent"
                                                            ? `Last Updated: ${sortOrderDate}`
                                                            : label}
                                                    </Button>
                                                )
                                            )}
                                        </Box>

                </Box>
            )}

            {mediaQueryVar ? null : (
              <>
                    {!isDataLoaded && (
                        <Box sx={{padding: "5px", backgroundColor: "#FFF", borderRadius: "8px", margin: "8px 0"}}>
                            {Array.from(new Array(rowsToShow)).map((_, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        padding: "16px",
                                        backgroundColor: "#F9F9F9",
                                        borderRadius: "8px",
                                        marginBottom: "16px",
                                    }}
                                >
                                    <Box sx={{display: "flex", alignItems: "center", marginBottom: "8px"}}>
                                        <Skeleton
                                            sx={{marginRight: "8px", borderRadius: "8px"}}
                                            variant="rectangular"
                                            width={40}
                                            height={40}
                                        />
                                        <Skeleton variant="text" width={200} height={30} />
                                    </Box>
                                    <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                        <Skeleton variant="text" width="50%" height={30} />
                                        <Skeleton variant="text" width="50%" height={30} />
                                        <Skeleton variant="text" width="50%" height={30} />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                      {!loading && (
    <>
                            {filteredData.length === 0 ? (
                            <Box
                                sx={{
                                    mt: 4,
                                    mb: 6,
                                    textAlign: "center",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    color: "#1877F2",
                                    border:"2px solid #1877F2",
                                    borderRadius:"10px",
                                    padding:"10px 20px"
                                }}
                            >
                                No Influencers Data found.
                            </Box>
                         ) : (
                          <>
                        
                            {filteredData.slice(0, rowsToShow).map((item, index) => (
                                <Box
                                    key={index}
                                    border="1px solid #1877F2"
                                    borderRadius="20px"
                                    p={0}
                                    mb={5}
                                    sx={{
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        sx={{
                                            position: "relative",
                                            borderRadius: "20px",
                                            background:
                                                "var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                                            fontWeight: 700,
                                            fontSize: "18px",
                                            px: 2,
                                            py: 1,
                                        }}
                                    >
                                        {item.photo ? (
                                            <img
                                                src={item.photo}
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                    borderRadius: "33px",
                                                    border: "2px solid black",
                                                    marginRight: "5px",
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={window.constants.asset_path + "/images/avtar.jpeg"}
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                    borderRadius: "33px",
                                                    border: "2px solid black",
                                                    marginLeft: "3px",
                                                    marginRight: "5px",
                                                }}
                                                alt="Default Profile Pic"
                                            />
                                        )}
                                        {item.forecaster_name}

                                        {/* Flat bottom line below the border radius */}
                                        <Box
                                            sx={{
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                right: 0,
                                                bottom: "-2px", // push below the curved edge
                                                height: "4px",
                                                backgroundColor: "#1877F2",
                                                borderRadius: 0, // explicitly remove radius
                                            }}
                                        />
                                    </Box>

                                    {/* Info Section */}
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        px={1.5}
                                        pt={3}
                                        pb={1}
                                    >
                                        {/* Rank */}
                                        <Typography variant="body2" sx={{color: "#000"}}>
                                            <span style={{fontSize: "14px", fontWeight: "400", marginRight: "20px"}}>
                                                Rank
                                            </span>
                                            <span style={{fontSize: "14px", fontWeight: "700"}}>#{item.rank}</span>
                                        </Typography>

                                        {/* Win Rate */}
                                        <Typography
                                            variant="body2"
                                            sx={{color: "#000", marginRight: "auto", marginLeft: "30%"}}
                                        >
                                            <span style={{fontSize: "14px", fontWeight: "400", marginRight: "20px"}}>
                                                ROI
                                            </span>
                                            <span style={{fontSize: "14px", fontWeight: "400"}}>{item.win_rate}</span>
                                        </Typography>
                                    </Box>

                                    <Box px={1.5} mt={1} mb={1}>
                                        <span style={{fontSize: "14px", fontWeight: "400", marginRight: "20px"}}>
                                            Last Updated{" "}
                                        </span>
                                        <span style={{fontSize: "14px", fontWeight: "400"}}>
                                            {formatDateTime(item.latest_updated_on)}
                                        </span>
                                    </Box>

                                    {/* Buttons Section */}
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        gap={2}
                                        mb={1.5}
                                        sx={{
                                            flexWrap: "nowrap",
                                            overflow: "visible", // allow shadows to show
                                        }}
                                    >
                                        <Button
                                            onClick={() =>
                                                window.open(
                                                    `../influencer/${item.forecaster_name.replace(
                                                        /\s+/g,
                                                        "-"
                                                    )}/portfolios`,
                                                    "_blank"
                                                )
                                            }
                                            variant="contained"
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: "700",
                                                background:
                                                    "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                color: "#000",
                                                borderRadius: "20px",
                                                px: 3,
                                                py: 1,
                                                textTransform: "none",
                                                boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                                                flexShrink: 1,
                                                minWidth: 0,
                                                maxWidth: "100%",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            View Portfolios
                                        </Button>

                                        <Button
                                            onClick={() =>
                                                window.open(
                                                    `../influencer/${item.forecaster_name.replace(/\s+/g, "-")}`,
                                                    "_blank"
                                                )
                                            }
                                            variant="contained"
                                            sx={{
                                                fontSize: "12px",
                                                fontWeight: "700",
                                                background:
                                                    "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                color: "#000",
                                                borderRadius: "20px",
                                                px: 2,
                                                py: 1,
                                                textTransform: "none",
                                                boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                                                flexShrink: 1,
                                                minWidth: 0,
                                                maxWidth: "100%",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            View Influencer Profile
                                        </Button>
                                    </Box>
                                </Box>
                            ))}

                            {rowsToShow < filteredData.length && (
                                <StyledTableRow>
                                    <StyledTableCell
                                        colSpan={6}
                                        align="center"
                                        style={{position: "relative", height: "100px"}}
                                    >
                                        <div className="loadingButton">
                                            <LoadingButton
                                                onClick={handleLoadMore}
                                                loadingPosition="center"
                                                variant="outlined"
                                                style={{
                                                    maxWidth: "360px",
                                                    width: "80vw",
                                                    backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                    borderRadius: "6px",
                                                    border: "none",
                                                    textTransform: "none",
                                                    borderStyle: "solid",
                                                    borderColor: "rgba(67, 97, 238, 0.15)",
                                                    borderWidth: "1px",
                                                    color: "#4361ee",
                                                    width: mediaQueryVar === false ? "80vw" : "180px",
                                                    marginBottom: "50px",
                                                }}
                                            >
                                                <span>Explore More</span>
                                            </LoadingButton>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                            </>
                         )}
    </>
                            
                            )}


                </>
            )}

            {mediaQueryVar ? (
                <div className="layout">
                    <div className>
                        <Box
                            component="nav"
                            sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                            aria-label="mailbox folders"
                        >
                            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                            <Drawer
                                container={container}
                                variant="temporary"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                                sx={{
                                    display: {xs: "block", sm: "none"},
                                    "& .MuiDrawer-paper": {
                                        boxSizing: "border-box",
                                        width: drawerWidth,
                                        backgroundColor: "white",
                                        color: "#727376",
                                    },
                                }}
                            >
                                {drawer}
                            </Drawer>
                            <Drawer
                                variant="permanent"
                                sx={{
                                    display: {xs: "none", sm: "block"},
                                    "& .MuiDrawer-paper": {
                                        boxSizing: "border-box",
                                        width: drawerWidth,
                                        backgroundColor: "white",
                                        color: "#727376",
                                    },
                                }}
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Box>
                    </div>

                    <div className="content">
                        {isLoginModalOpen && (
                            <LoginPopUp
                                isLoginModalOpen={isLoginModalOpen}
                                setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                                onClose={handleModalClose}
                            />
                        )}

                        <TableContainer
                            style={{
                                width: "96%",
                                overflowX: "hidden",
                                borderRadius: "10px",
                                padding: 0,
                                marginTop: "1.5%",
                                marginBottom: "5%",
                                marginLeft: "2%",
                                
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    padding: "3%",
                                    paddingTop: "2%",
                                    borderRadius: "8px",
                                    marginTop: "150px",
                                }}
                            >
                                <Box p={2}>
                                    {/* Tabs + Search + Notification */}
                                    <Box mb={3}>
                                        {/* Search Bar Section (New Line) */}
                                        <Box mt={0} mb={4}>
                                            <TextField
                                                placeholder="Search Portfolios, Predictions Cryptos"
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                                size="small"
                                                sx={{
                                                    width: "60%",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "50px",
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "46px",
                                                        height: "48px",
                                                        paddingRight: "8px",
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "12px 8px", // Controls input text padding
                                                            height: "24px", // Ensures proper vertical alignment
                                                        },
                                                        "& fieldset": {
                                                            border: "1px solid #1877F2",
                                                        },
                                                    },
                                                    "& input::placeholder": {
                                                        color: "#1877F2",
                                                        opacity: 1,
                                                        fontSize: "16px",
                                                        fontWeight: "400",
                                                    },
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <img
                                                                src="/images/search-new-2.svg"
                                                                alt="search"
                                                                width="18.872"
                                                                height="18.868"
                                                                style={{marginLeft: "20px"}}
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Box>

                                    {/* Sort Section */}
                                    

                                    {/* Header */}
                                    <Box
                                        position="relative"
                                        px={2}
                                        py={1}
                                        borderRadius="10px"
                                        overflow="hidden"
                                        style={{
                                            background: "transparent",
                                        }}
                                    >
                                        {/* Blurred Background Layer */}
                                        <Box
                                            position="absolute"
                                            top={0}
                                            left={0}
                                            right={0}
                                            bottom={0}
                                            sx={{
                                                background:
                                                    "linear-gradient(180deg, rgba(24, 119, 242, 0.11) -1.89%, rgba(24, 119, 242, 0.00) 60.38%)",
                                                filter: "blur(2px)",
                                                borderBottom: "5px solid #1877F2",
                                                zIndex: 0,
                                            }}
                                        />

                                        {/* Foreground Content */}
                                        <Box
                                            display="flex"
                                            position="relative"
                                            zIndex={1}
                                            style={{fontSize: "18px", fontWeight: "700"}}
                                        >
                                            <Box flex={2.5} textAlign="left">
                                                Influencer Name
                                            </Box>
                                            <Box flex={0.35} />
                                            <Box flex={1} textAlign="center" onClick={handleSortRank} style={{ cursor: "pointer" }}>
                                                Rank <span>{sortOrderRank === "Highest To Lowest" ? "↓" : "↑"}</span>
                                            </Box>
                                            <Box flex={0.2} />
                                            <Box flex={1.2} textAlign="center" onClick={handleSortWinRate} style={{ cursor: "pointer" }}>
                                                ROI <span>{sortOrderWinRate === "High To Low" ? "↓" : "↑"}</span>
                                            </Box>
                                            <Box flex={3}></Box> {/* For buttons */}
                                            <Box flex={2} textAlign="right" onClick={handleSortDate} style={{ cursor: "pointer" }}>
                                                Last Updated <span>{sortOrderDate === "Most Recent" ? "↓" : "↑"}</span>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {filteredData && loading ? (
                                          Array.from({length: rowsToShow}).map((_, index) => (
                                              <Box
                                                  key={index}
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  p={1}
                                                  mt={4}
                                                  border="1px solid #ccc"
                                                  borderRadius="20px"
                                                  background="#f9f9f9"
                                              >
                                                  <Skeleton
                                                      variant="rectangular"
                                                      width="14vw"
                                                      height={40}
                                                      sx={{borderRadius: "20px"}}
                                                  />
                                                  <Box flex={0.43} />
                                                  <Skeleton variant="text" width={40} height={30} />
                                                  <Box flex={0.6} />
                                                  <Skeleton variant="text" width={60} height={30} />
                                                  <Box flex={0.3} />
                                                  <Box flex={4} display="flex" gap={1} justifyContent="center">
                                                      <Skeleton variant="rounded" width={150} height={32} />
                                                      <Skeleton variant="rounded" width={150} height={32} />
                                                  </Box>
                                                  <Skeleton variant="text" width={100} height={30} />
                                              </Box>
                                          ))
                                    ): filteredData.length === 0 ?(
                                          // Show "No Portfolios Found" when filteredData is empty
                                        <Box
                                            mt={4}
                                            textAlign="center"
                                            fontSize="20px"
                                            fontWeight="500"
                                            color="#1877F2"
                                            border="2px solid #1877F2"
                                            borderRadius = "15px"
                                            padding = "20px 20px"
                                        >
                                            No Influencer Data found.
                                        </Box>
                                    ):(
                                         filteredData.slice(0, rowsToShow).map((item, index) => (
                                              <Box
                                                  key={index}
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  p={1}
                                                  mt={4}
                                                  border="1px solid #1877F2"
                                                  borderRadius="20px"
                                                  background="#fff"
                                              >
                                                  {/* Influencer Name */}
                                                  <Box
                                                      flex={1.5}
                                                      sx={{
                                                          fontWeight: "700",
                                                          color: "#000",
                                                          fontSize: "17px",
                                                          background:
                                                              "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                          padding: "10px 6px",
                                                          border: "1.8px solid rgba(24, 119, 242, 0.00)",
                                                          borderRadius: "20px",
                                                          textAlign: "left",
                                                          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                          minWidth: "17vw",
                                                          maxWidth: "17vw",
                                                      }}
                                                  >
                                                      {item.photo ? (
                                                          <img
                                                              src={item.photo}
                                                              style={{
                                                                  width: "38px",
                                                                  height: "38px",
                                                                  borderRadius: "33px",
                                                                  border: "2px solid black",
                                                                  marginRight: "5px",
                                                              }}
                                                          />
                                                      ) : (
                                                          <img
                                                              src={window.constants.asset_path + "/images/avtar.jpeg"}
                                                              style={{
                                                                  width: "38px",
                                                                  height: "38px",
                                                                  borderRadius: "33px",
                                                                  border: "2px solid black",
                                                                  marginLeft: "3px",
                                                                  marginRight: "5px",
                                                              }}
                                                              alt="Default Profile Pic"
                                                          />
                                                      )}
                                                      {item.forecaster_name}
                                                  </Box>
                                                  <Box flex={0.43} />

                                                  {/* Rank */}
                                                  <Box flex={1} textAlign="center" fontWeight="700" fontSize="18px">
                                                      #{item.rank}
                                                  </Box>
                                                  <Box flex={0.4} />
                                                  {/* Win Rate */}
                                                  <Box flex={1} textAlign="center" fontWeight="400" fontSize="18px">
                                                      {item.win_rate}
                                                  </Box>
                                                  <Box flex={0.3} />
                                                  {/* Buttons */}
                                                  <Box flex={4} display="flex" gap={1} justifyContent="center">
                                                      <Button
                                                          onClick={() =>
                                                              window.open(
                                                                  `../influencer/${item.forecaster_name.replace(
                                                                      /\s+/g,
                                                                      "-"
                                                                  )}/portfolios`,
                                                                  "_blank"
                                                              )
                                                          }
                                                          variant="contained"
                                                          sx={{
                                                              fontSize: "14px",
                                                              fontWeight: "700",
                                                              background:
                                                                  "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                              color: "#000",
                                                              borderRadius: "20px",
                                                              padding: "8px 18px 9.692px 18px",
                                                              textTransform: "none",
                                                              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                              width: "150px",
                                                              height: "32.692px",
                                                              marginTop: "2%",
                                                          }}
                                                      >
                                                          View Portfolios
                                                      </Button>
                                                      <Box flex={0.05} />
                                                      <Button
                                                          onClick={() =>
                                                              window.open(
                                                                  `../influencer/${item.forecaster_name.replace(
                                                                      /\s+/g,
                                                                      "-"
                                                                  )}`,
                                                                  "_blank"
                                                              )
                                                          }
                                                          variant="contained"
                                                          sx={{
                                                              fontSize: "14px",
                                                              fontWeight: "700",
                                                              lineHeight: "1.2", // 👈 This reduces vertical space between lines
                                                              background:
                                                                  "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                                              color: "#000",
                                                              borderRadius: "20px",
                                                              padding: "2px 18px 1px 18px",
                                                              textTransform: "none",
                                                              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                                              width: "150px",
                                                              height: "32.692px",
                                                              marginTop: "2%",
                                                          }}
                                                      >
                                                          View Influencer Profile
                                                      </Button>
                                                  </Box>

                                                  {/* Last Updated */}
                                                  <Box
                                                      flex={2}
                                                      textAlign="right"
                                                      fontSize="18px"
                                                      fontWeight={400}
                                                      mr={2}
                                                  >
                                                      {formatDateTime(item.latest_updated_on)}
                                                  </Box>
                                              </Box>
                                          ))
                                    )}
                                        
                                  {filteredData && filteredData.length > rowsToShow && (     
                                    <Box display="flex" justifyContent="center" mt={4}>
                                        <LoadingButton
                                            onClick={handleLoadMore}
                                            loadingPosition="center"
                                            variant="outlined"
                                            style={{
                                                maxWidth: "360px",
                                                width: mediaQueryVar === false ? "80vw" : "180px",
                                                backgroundColor: "rgba(67, 97, 238, 0.15)",
                                                borderRadius: "6px",
                                                border: "none",
                                                textTransform: "none",
                                                borderStyle: "solid",
                                                borderColor: "rgba(67, 97, 238, 0.15)",
                                                borderWidth: "1px",
                                                color: "#4361ee",
                                                marginBottom: "0px",
                                            }}
                                        >
                                            <span>Explore More</span>
                                        </LoadingButton>
                                    </Box>
                                  )}
                                </Box>
                                
                            </div>
                        </TableContainer>
                    </div>
                </div>
            ) : null}
            {mediaQueryVar === false && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0",
                        backgroundColor: "white",
                        width: "100%",
                        zIndex: "100",
                        marginBottom: "0px",
                        marginLeft: "-20px",
                    }}
                >
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label="Top Portfolios"
                            onClick={() => navigate("/portfolio-gallery")}
                            icon={
                                <img
                                    src={
                                        loc === "/portfolio-gallery"
                                            ? "/images/dashboardS.svg"
                                            : "/images/dashboardU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="My Portfolios"
                            onClick={() => {
                                navigate(
                                    userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"
                                );
                            }}
                            icon={
                                <img
                                    src={
                                        loc === "/my-portfolio/detailed-portfolio-analysis"
                                            ? "/images/portfolioS.svg"
                                            : "/images/portfolioU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Crypto Screener"
                            onClick={() => navigate("/crypto-screener")}
                            icon={
                                <img
                                    src={
                                        loc === "/crypto-screener" ? "/images/portfolioS.svg" : "/images/portfolioU.svg"
                                    }
                                    width={"20px"}
                                    height={"20px"}
                                />
                            }
                        />
                    </BottomNavigation>
                </div>
            )}
        </div>
    );
};

export default CryptoInfluencerRankings;
